__turbopack_context__.v({
  "desktopPincodeWrapper": "_0yp4VG_desktopPincodeWrapper",
  "genderOption": "_0yp4VG_genderOption",
  "genderOptionText": "_0yp4VG_genderOptionText",
  "genderOptionsContainer": "_0yp4VG_genderOptionsContainer",
  "genderSelectionTitle": "_0yp4VG_genderSelectionTitle",
  "genderSelectionWrapper": "_0yp4VG_genderSelectionWrapper",
  "radioButton": "_0yp4VG_radioButton",
  "separator": "_0yp4VG_separator",
  "sidebar": "_0yp4VG_sidebar",
});
